import commonMapping from "@/mapping/common";

const radio2g_preamble_list = [
  { value: "automatic", config: "auto", label: "sec_auto" },
  { value: "Long Preamble", label: "adva_wlan_pream_long", config: "long" },
  { value: "Short Preamble", label: "adva_wlan_pream_short", config: "short" },
];
const radio2g_tpc_mode_list = [
  { value: "100", label: "100%", config: "100" },
  // { value: "75", label: "75%", config: "75" },
  { value: "50", label: "50%", config: "50" },
  { value: "25", label: "25%", config: "25" },
];
const radio5g_preamble_list = [
  { value: "automatic", config: "auto", label: "sec_auto" },
  { value: "Long Preamble", label: "adva_wlan_pream_long", config: "long" },
  { value: "Short Preamble", label: "adva_wlan_pream_short", config: "short" },
];
const radio5g_tpc_mode_list = [
  { value: "100", config: "100", label: "100%" },
  // { value: "75", label: "75%", config: "75" },
  { value: "50", label: "50%", config: "50" },
  { value: "25", label: "25%", config: "25" },
];
const wireless_schedule_day_list = [
  { value: "0", config: "0", label: "Sun." },
  { value: "1", config: "1", label: "Mon." },
  { value: "2", config: "2", label: "Tues." },
  { value: "3", config: "3", label: "Wed." },
  { value: "4", config: "4", label: "Thu." },
  { value: "5", config: "5", label: "Fri." },
  { value: "6", config: "6", label: "Sat." },
];

const wireless_schedule_time_12_list = [];
for (let i = 0; i < 48; i++) {
  const item = { value: i.toString(), config: i.toString(), label: "", label1: "" };
  let label = "";
  const hour = Math.floor(i / 2);
  if (i == 0) {
    item.label1 = "midnight_mark";
  } else if (i > 0 && i < 24) {
    item.label1 = "a.m.";
  } else if (i == 24) {
    item.label1 = "noon_mark";
  } else {
    item.label1 = "p.m.";
  }
  if (hour == "0") {
    label = "12";
  } else if (hour > 12) {
    label = hour < 22 ? "0" + (hour - 12).toString() : (hour - 12).toString();
  } else {
    label = hour < 10 ? "0" + hour.toString() : hour.toString();
  }
  if (i % 2 === 0) {
    label += ":00 ";
  } else {
    label += ":30 ";
  }
  item.label = label;
  wireless_schedule_time_12_list.push(item);
}

const wireless_schedule_time_24_list = [];
for (let i = 0; i < 48; i++) {
  const item = { value: i.toString(), config: i, label: "" };
  let label = "";
  const hour = Math.floor(i / 2);
  label = hour < 10 ? "0" + hour.toString() : hour.toString();
  if (i % 2 === 0) {
    label += ":00";
  } else {
    label += ":30";
  }
  item.label = label;
  wireless_schedule_time_24_list.push(item);
}

const schedule_recur_add_list = [
  { label: "email_daily", value: "0", id: "schedule_daily" },
  { label: "adva_select_days", value: "1", id: "schedule_select" },
];

const day_add_list = [
  { value: "0", label: "schedule_sun", id: "cbox_sunday" },
  { value: "1", label: "schedule_mon", id: "cbox_monday" },
  { value: "2", label: "schedule_tue", id: "cbox_tuesday" },
  { value: "3", label: "schedule_wed", id: "cbox_wednesday" },
  { value: "4", label: "schedule_thu", id: "cbox_thursday" },
  { value: "5", label: "schedule_fri", id: "cbox_friday" },
  { value: "6", label: "schedule_sat", id: "cbox_saturday" },
];

const schedule_recur_edit_list = [
  { label: "email_daily", value: "0", id: "selday_da" },
  { label: "adva_select_days", value: "1", id: "selday_day" },
];

const day_edit_list = [
  { value: "0", label: "schedule_sun", id: "sun" },
  { value: "1", label: "schedule_mon", id: "mon" },
  { value: "2", label: "schedule_tue", id: "tue" },
  { value: "3", label: "schedule_wed", id: "wed" },
  { value: "4", label: "schedule_thu", id: "thu" },
  { value: "5", label: "schedule_fri", id: "fri" },
  { value: "6", label: "schedule_sat", id: "sat" },
];

const pmf_list = [
  { value: "disabled", label: "disabled", config: "disabled" },
  { value: "optional", label: "optional", config: "optional" },
  { value: "required", label: "required", config: "required" },
];

export const advWireless = {
  region: commonMapping.regionList,
  radio2g_broadcast: commonMapping.intToBoolean,
  radio2g_obss_coex: commonMapping.intToBoolean,
  radio2g_wmm: commonMapping.intToBoolean,
  radio2g_enable: commonMapping.intToBoolean,
  radio2g_preamble: radio2g_preamble_list,
  radio2g_tpc_mode: radio2g_tpc_mode_list,
  wireless_radio2g_enable: commonMapping.intToBoolean,
  radio5g_enable: commonMapping.intToBoolean,
  radio5g_broadcast: commonMapping.intToBoolean,
  radio5g_wmm: commonMapping.intToBoolean,
  radio5g_preamble: radio5g_preamble_list,
  radio5g_tpc_mode: radio5g_tpc_mode_list,
  wireless_radio5g_enable: commonMapping.intToBoolean,
  mumimo: commonMapping.intToBoolean,
  beamforming_enable: commonMapping.intToBoolean,
  pmf_disable: commonMapping.intToBoolean,
  schedule_time_12: wireless_schedule_time_12_list,
  schedule_time_24: wireless_schedule_time_24_list,
  wireless_schedule_day: wireless_schedule_day_list,
  "add.recur": schedule_recur_add_list,
  "add.day": day_add_list,
  "edit.recur": schedule_recur_edit_list,
  "edit.day": day_edit_list,
  pmf: pmf_list,
  satellite_ignore_enable: commonMapping.intToBoolean,
  rate: commonMapping.intToBoolean,
};

export default advWireless;
